import type { ProductCode } from '@common/api/productContext';

import { getAdminProductFeatures } from './adminProductFeatures';

export const isMarketIntelligenceAdminAvailableFor = (productCode: ProductCode, mvpEnabled: boolean): boolean =>
    mvpEnabled && getAdminProductFeatures(productCode).marketIntelligence;
